import { PreorderProductDTO } from '@/api/dto/PreorderProductDTO';
import { PreorderProduct } from '@/models/entities/PreorderProduct';
import { CrudModule, IModuleState } from './CrudModule';
import { EntityType } from '@/store/entityModules/types';
import { SearchQueryFilters } from '@/models/filters/SearchQueryFilters';
import { GetterTree, ActionTree } from 'vuex';
import { ISearchFilter, ITableHeader } from '@/models/filters/Filters';

class PreorderProductsModule extends CrudModule<PreorderProduct, PreorderProductDTO> {
  state: IModuleState<PreorderProduct, PreorderProductDTO> = {
    ...this.state,

    entityType: EntityType.PREORDER_PRODUCT,
    queryFilters: new SearchQueryFilters({}),
  };

  getters: GetterTree<IModuleState<PreorderProduct, PreorderProductDTO>, any> = {
    ...this.getters,

    getItem: state => (id: number) => {
      const item = state.items.find((i: PreorderProduct) => i.id === id);
      return item || null;
    },

    getSearchHeaders(state): ITableHeader[] {
      const filter = state.queryFilters as SearchQueryFilters;
      if (!filter.searchFilter) return [];
      return filter.searchFilter.headers;
    },
  };

  actions: ActionTree<IModuleState<PreorderProduct, PreorderProductDTO>, any> = {
    ...this.actions,

    setSearchValue({ getters, commit }, value: string | null) {
      commit('setQueryFilters', {
        searchFilter: {
          value,
          headers: getters['getSearchHeaders'],
        },
        // show results from the 1st page
        page: 1,
      });
    },

    setCustomSearchField({ state }, searchFields: ISearchFilter) {
      if (state.customFilters) {
        state.customFilters.searchFilter = searchFields;
        state.customFilters.page = 1;
      }
    },

    setCheckboxFilterField({ state, commit }, value: boolean) {
      const fieldFilter = value
        ? {
            filterBy: 'preorderOnly',
            filterValue: value,
          }
        : null;

      commit('setQueryFilters', {
        fieldFilter: fieldFilter,
        page: 1,
      });
    },

    setSearchHeaders({ commit, getters }, value: ITableHeader[]) {
      commit('setQueryFilters', {
        searchFilter: {
          headers: value,
        },
      });
    },
  };
}

const preorderProductsModule = new PreorderProductsModule();
export default preorderProductsModule;
